import { useContext } from 'react'
import { AuthContext } from "../../context/AuthContext";
import {
  Box,
  Flex,
  IconButton,
  HStack,
  Circle, Menu, MenuButton, MenuList, MenuItem
} from '@chakra-ui/react';
import { FaUser, FaCar, FaRocketchat, FaList, FaHome } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';

const Footer = () => {

  const navigate = useNavigate();
  const { logout } = useContext(AuthContext);

  const goTo = (page) => {
    navigate(page)
  }

  return (
    <Box position="fixed" bottom="0" left="0" right="0" bg="gray.300" height="50px" zIndex={10}>
      <Flex justify="center" align="center" height="100%" position="relative">
        <HStack spacing={4}>
          {/* Profile Menu */}
          <Menu>
            <MenuButton
              as={IconButton}
              icon={<FaUser />}
              aria-label="Profile Menu"
              borderRadius="full"
            />
            <MenuList>
              <MenuItem onClick={() => goTo("/admin/profile")}>Profile</MenuItem>
              <MenuItem onClick={() => goTo("/admin/change-password")}>Change Password</MenuItem>
              <MenuItem onClick={logout}>
                Logout
              </MenuItem>
            </MenuList>
          </Menu>

          <IconButton
            icon={<FaList />}
            aria-label="Map"
            borderRadius="full"
            onClick={() => goTo("/admin/users")}
          />

          {/* Center Button */}
          <Box position="relative" top="-15px">
            <Circle size="70px" bg="yellow.500" color="white" border="4px solid pink">
              <FaHome size={25} onClick={() => goTo("/admin")} />
            </Circle>
          </Box>

          <IconButton
            icon={<FaCar />}
            aria-label="Vehicles"
            borderRadius="full"
            onClick={() => goTo("/admin/vehicles")}
          />
          <IconButton icon={<FaRocketchat />} aria-label="Settings" borderRadius="full"
            onClick={() => goTo("/admin/chatmsg")}
          />
        </HStack>
      </Flex>
    </Box>
  )
}

export default Footer
